import { Grid } from '@/components/Grid';
import Pagination from '@/components/Grid/Pagination';
import { EXPAND_OPTIONS } from '@/constants/grid';
import { useAppDispatch } from '@/store/hooks';
import { setFilters } from '@/store/slices/firstPartyDataSlice';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import { GridLogicOperator } from '@mui/x-data-grid-pro';
import PropTypes from 'prop-types';
import { useCallback, useEffect, useMemo, useState } from 'react';
import ToolBar from './Components/ToolBar';
import { getColumns } from './columns';

const FirstPartyDataGrid = ({ data = [], loading, rowCount, handleOpenNewFileModal, filters, clients }) => {
  const dispatch = useAppDispatch();

  //#region sort and pagination
  const [sortModel, setSortModel] = useState([]);
  const [filterModel, setFilterModel] = useState({
    items: [],
    quickFilterLogicOperator: GridLogicOperator.Or,
    logicOperator: GridLogicOperator.Or,
    quickFilterValues: [],
  });

  const onFilterModelChange = newFilterModel => setFilterModel(newFilterModel);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 15,
  });

  const setPagination = useCallback(pagination => dispatch(setFilters({ ...pagination })), [dispatch]);

  const handlePaginationModelChange = newPaginationModel => {
    setPaginationModel(newPaginationModel);
    setPagination({ page: newPaginationModel.page + 1, limit: newPaginationModel.pageSize });
  };

  const handleSortModelChange = newSortModel => {
    setSortModel(newSortModel);
  };

  useEffect(() => {
    setPaginationModel(oldModel => ({ ...oldModel, page: filters.page - 1 }));
  }, [filters.page]);
  //#endregion

  //#region columns
  const COLUMNS = useMemo(() => getColumns(), []);
  //#endregion

  return (
    <div className='grid grid-cols-1'>
      <Grid
        rows={data}
        loading={loading}
        autosizeOnMount
        autosizeOptions={EXPAND_OPTIONS}
        disableRowSelectionOnClick
        disableColumnFilter
        disableColumnMenu
        disableColumnSelector
        columns={COLUMNS}
        columnHeaderHeight={30}
        rowCount={rowCount}
        filterModel={filterModel}
        onFilterModelChange={onFilterModelChange}
        paginationModel={paginationModel}
        onPaginationModelChange={handlePaginationModelChange}
        sortModel={sortModel}
        onSortModelChange={handleSortModelChange}
        pagination
        slots={{
          pagination: Pagination,
          toolbar: ToolBar,
          columnSortedAscendingIcon: KeyboardArrowUp,
          columnSortedDescendingIcon: KeyboardArrowDown,
        }}
        slotProps={{
          pagination: {
            loading,
            rowCount,
          },
          footer: {
            className: 'relative',
          },
          toolbar: {
            setQuickFilter: quickFilterValues => setFilterModel({ ...filterModel, quickFilterValues }),
            handleOpenNewFileModal,
            loading,
            clients,
            filters,
          },
        }}
      />
    </div>
  );
};

FirstPartyDataGrid.propTypes = {
  data: PropTypes.array,
  loading: PropTypes.bool,
  rowCount: PropTypes.number,
  handleOpenNewFileModal: PropTypes.func,
  filters: PropTypes.object,
  clients: PropTypes.array,
};

export default FirstPartyDataGrid;
